export default __webpack_public_path__ + "static/media/speechH1.ad7ca236.png";